<div class="toast-wrapper mat-elevation-z6 {{ data.panelClass }}" [ngClass]="data.type">

  <div class="accent-bar"></div>

  <div class="icon-area">
    <div class="icon-circle">
      <mat-icon>{{ typeIcon }}</mat-icon>
    </div>
  </div>

  <div class="body">
    <div class="title">{{ data.title }}</div>
    <div class="subtitle" *ngIf="data.subTitle">{{ data.subTitle }}</div>
    <div class="timestamp" *ngIf="data.date">{{ data.date }}</div>
  </div>

  <button class="action-btn" *ngIf="data.onAction" (click)="action()">
    {{ data.actionLabel }}
  </button>
  <button class="close-btn" mat-icon-button *ngIf="!data.onAction" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="progress-bar" *ngIf="data.time" [style.animation-duration.ms]="toastTime"></div>

</div>
